import heroImage from "../assets/service-hero2.jpg";
import { Link } from "react-router-dom";
import litigation from "../assets/litigation.png";
import criminal from "../assets/criminal law.webp";
import conveyancing from "../assets/land-law-conveyancing.jpg";
import commercial from "../assets/commercial-property.jpg";
import consultancy from "../assets/consultancy.png";
import family from "../assets/family -law.webp";


function Services() {


  const services = [
  {
    name: "Litigation & Dispute Resolution ",
    image: litigation,
    link: "/services/litigation",
  },
  {
    name: "Conveyance & Real Estate",
    image: conveyancing,
    link: "/services/conveyancing",
  },
  {
    name: "Criminal Defence",
    image: criminal,
    link: "/services/criminal",
  },
  {
    name: " Corporate & Commercial Law",
    image: commercial,
    link: "/services/commercial",
  },
  {
    name: "General Legal Consultancy",
    image: consultancy,
    link: "/services/intellectual",
  },
  {
    name: "Family & Succession Law",
    image: family,
    link: "/services/probate",
  },
];
  return (
    <>
      {/* ================= HERO SECTION ================= */}
      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">

        {/* BACKGROUND IMAGE */}
        <div
          className="absolute inset-0 bg-cover bg-center scale-105"
          style={{
            backgroundImage: `url(${heroImage})`,
          }}
        ></div>

        {/* OVERLAY */}
        <div className="absolute inset-0 bg-black/70"></div>

        {/* CONTENT */}
        <div className="relative z-10 text-center px-6 max-w-3xl text-white">

          {/* BREADCRUMB */}
          <p className="text-sm text-gray-300 mb-3">
          
          </p>

          {/* TITLE */}
          <h1 className="text-4xl md:text-5xl font-bold leading-tight">
            Areas of Practice
          </h1>

          {/* DESCRIPTION */}
          <p className="mt-4 text-gray-200 text-lg">
            
          </p>

        </div>
      </section>
      {/* ================= SERVICES GRID ================= */}
<section className="py-20 px-6 bg-gray-50">
  <div className="max-w-7xl mx-auto text-center">

    {/* TITLE */}
    <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
      Our Practice Areas
    </h2>

    <p className="mt-4 text-gray-600 max-w-2xl mx-auto">
      Explore our legal services tailored to meet your needs.
    </p>

    {/* GRID */}
    <div className="mt-12 grid sm:grid-cols-2 md:grid-cols-4 gap-8">

      {services.map((item, index) => (
        <Link
          key={index}
          to={item.link}
          className="group relative overflow-hidden rounded-xl shadow-lg"
        >
          {/* IMAGE */}
          <img
            src={item.image}
            alt={item.name}
            className="w-full h-56 object-cover group-hover:scale-110 transition duration-700"
          />

          {/* OVERLAY */}
          <div className="absolute inset-0 bg-black/40 group-hover:bg-black/70 transition duration-500"></div>

          {/* TEXT */}
          <h3 className="absolute bottom-4 left-4 text-white text-lg font-semibold">
            {item.name}
          </h3>

        </Link>
      ))}

    </div>

  </div>
</section>
    </>
  );
}

export default Services;